import { styled } from '@styledComponents';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { animationTransition } from '@utils/animationTransition';
import { Columns, Column } from '@components/Columns';
import { ButtonNoneStyled } from '@components/ButtonNoneStyled';

export const GridWrapper = styled.div`
  width: 100%;
  margin-top: ${themeSpace(-9)};
  ${themeMediaQuery('sm')} {
    margin-top: ${themeSpace(-10)};
  }
`;

export const StyledCell = styled(ButtonNoneStyled)<{ marginTop: number }>`
  margin-top: ${({ marginTop }) => themeSpace(marginTop)};
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(9)};
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
`;

export const ECardWrapper = styled.div<{ $isHovered: boolean }>`
  transform: scale(${({ $isHovered }) => ($isHovered ? 1.05 : 1.001)});
  transition: ${animationTransition('transform')};
`;

export const ECardTitle = styled(Text)`
  margin-top: ${themeSpace(6)};
  ${themeMediaQuery('below_sm')} {
    max-width: 42vw;
    text-overflow: ellipsis;
    overflow-x: hidden;
  }
`;

export const ECardSubTitle = styled(Text)`
  margin-top: ${themeSpace(1)};
`;

export const StyledECardColumn = styled(Column)`
  ${themeMediaQuery('below_sm')} {
    display: inline-block;
  }
`;

export const StyledECardColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: ${themeSpace(3)};
    padding-right: ${themeSpace(3)};
    max-width: 40rem;
  }
`;
